import MonitoringTableToolbar from './MonitoringTableToolbar'

export default MonitoringTableToolbar
